module.exports = __webpack_public_path__ + "static/media/rates-home.a3a6709a.svg";